import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrefissiInternazionali {

  private readonly prefissiInternazionali = [
    { flag: 'IT', value: '+39' },     // Italia
    { flag: 'FR', value: '+33' },     // Francia
    { flag: 'DE', value: '+49' },     // Germania
    { flag: 'ES', value: '+34' },     // Spagna
    { flag: 'GB', value: '+44' },     // Regno Unito
    { flag: 'US', value: '+1' },      // Stati Uniti
    { flag: 'CH', value: '+41' },     // Svizzera
    { flag: 'AT', value: '+43' },     // Austria
    { flag: 'PT', value: '+351' },    // Portogallo
    { flag: 'RO', value: '+40' },     // Romania
    { flag: 'BE', value: '+32' },     // Belgio
    { flag: 'NL', value: '+31' },     // Paesi Bassi
    { flag: 'LU', value: '+352' },    // Lussemburgo
    { flag: 'IE', value: '+353' },    // Irlanda
    { flag: 'GR', value: '+30' },     // Grecia
    { flag: 'SE', value: '+46' },     // Svezia
    { flag: 'NO', value: '+47' },     // Norvegia
    { flag: 'FI', value: '+358' },    // Finlandia
    { flag: 'DK', value: '+45' },     // Danimarca
    { flag: 'PL', value: '+48' },     // Polonia
    { flag: 'CZ', value: '+420' },    // Repubblica Ceca
    { flag: 'HU', value: '+36' },     // Ungheria
    { flag: 'SK', value: '+421' },    // Slovacchia
    { flag: 'SI', value: '+386' },    // Slovenia
    { flag: 'HR', value: '+385' },    // Croazia
    { flag: 'BG', value: '+359' },    // Bulgaria
    { flag: 'EE', value: '+372' },    // Estonia
    { flag: 'LV', value: '+371' },    // Lettonia
    { flag: 'LT', value: '+370' },    // Lituania
    { flag: 'MT', value: '+356' },    // Malta
    { flag: 'CY', value: '+357' },    // Cipro
    { flag: 'AU', value: '+61' },     // Australia
    { flag: 'CA', value: '+1' },      // Canada
    { flag: 'JP', value: '+81' },     // Giappone
    { flag: 'CN', value: '+86' },     // Cina
    { flag: 'IN', value: '+91' },     // India
    { flag: 'BR', value: '+55' },     // Brasile
    { flag: 'AR', value: '+54' },     // Argentina
    { flag: 'MX', value: '+52' },     // Messico
    { flag: 'RU', value: '+7' },      // Russia
    { flag: 'ZA', value: '+27' },     // Sudafrica
    { flag: 'EG', value: '+20' },     // Egitto
    { flag: 'TR', value: '+90' },     // Turchia
    { flag: 'KR', value: '+82' },     // Corea del Sud
    { flag: 'NZ', value: '+64' }      // Nuova Zelanda
  ];


  getPrefissi(): { flag: string, value: string }[] {
    return this.prefissiInternazionali;
  }

  constructor() { }
}
